import { urlSchema } from '../schema';

/**
 * Reads URLSearchParams and returns a clean state object based on schema
 */
export const parseUrlToState = (searchString) => {
  const params = new URLSearchParams(searchString);
  const result = {};

  Object.keys(urlSchema).forEach((param) => {
    const config = urlSchema[param];
    const key = config.key || param;
    const backupKey = config.backupKey;

    // Handle array types vs single values
    const rawValue = config.isMulti
      ? (params.getAll(key) || params.getAll(backupKey))
      : (params.get(key) || params.get(backupKey));
    const parsedValue = config.parse(rawValue);
    const isValueValid = config.validate ? config.validate(parsedValue) : true;

    result[param] = isValueValid ? parsedValue : config.defaultValue;
  });

  return result;
};

/**
 * Converts state object to URL search string
 */
export const buildUrlString = (state) => {
  const params = new URLSearchParams();

  Object.keys(urlSchema).forEach((param) => {
    const config = urlSchema[param];
    const value = state[param];
    const key = config.key || param;
    const backupKey = config.backupKey;

    if (value === undefined) return;

    const serialized = serializeParameter(param, value);

    if (config.isMulti && Array.isArray(serialized)) {
      serialized.forEach(item => params.append(key, item));
    } else if (serialized !== null && serialized !== '') {
      params.set(key, serialized);
    }

    if (backupKey) {
      if (config.isMulti && Array.isArray(serialized)) {
        serialized.forEach(item => params.append(backupKey, item));
      } else if (serialized !== null && serialized !== '') {
        params.set(backupKey, serialized);
      }
    }
  });

  return params.toString();
};

export const serializeParameter = function (key, value) {
  const config = urlSchema[key];
  return config.serialize(value);
};
